import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { QuickGuideReportRepositoryInterface } from '@/data/persistences/repositories/contracts/QuickGuideReportRepositoryInterface'
import { QuickGuideReport, Export } from '@/domain/entities/QuickGuideReport'
import { QuickGuideReportDataMapper } from '@/data/persistences/mappers/QuickGuideReportDataMappers'

@injectable()
export class QuickGuideReportApiRepository
  implements QuickGuideReportRepositoryInterface {
  private service: ApiService
  private mapper: QuickGuideReportDataMapper

  constructor(service: ApiService, mapper: QuickGuideReportDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<QuickGuideReport> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.REPORT_QUICKGUIDE,
      params
    )
    return this.mapper.convertQuickGuideReportFromApi(resp)
  }
  public async getExport(params: Object): Promise<Export> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.EXPORT_GUIDE,
      params
    )
    return this.mapper.convertExportFileFromAPi(resp)
  }
}
